import React, { FC, useCallback, useMemo } from 'react'
import { useQuery, useReactiveVar } from '@apollo/client'

import { FilterProjects } from 'modulesCommon/Filters/components'
import { GET_USERS } from 'modulesCommon/graphql/queries'

import { projectsFiltersVar, projectsTotalVar } from 'modules/Projects/store'
import { labelCodeIdVar, showMyFilterForZoneVar, spaceIdVar } from 'modulesCommon/store'
import { PROJECT_FILTER_INIT_VALUES, PROJECT_FILTER_STORAGE_NAME } from 'shared/consts/filter'
import { getFromLocalStorageDefValues } from 'shared/utils/getFromLocalStorage'
import { formatFiltersParams } from 'shared/utils/filters'
import { useFormattedZoneList, useLoading, useServerError } from 'shared/hooks'
import { useZonesList } from 'modulesCommon/serviceHooks'
import { useSpaceZone } from '../serviceHooks/useSpaceZone'

const FilterProjectsContainer: FC = () => {
  const showMyFilterForZone = useReactiveVar(showMyFilterForZoneVar)
  const currentLabel = useReactiveVar(labelCodeIdVar)
  const projectsTotal = useReactiveVar(projectsTotalVar)
  const spaceId = useReactiveVar(spaceIdVar)
  const { zoneList, zoneError, zoneLoading } = useZonesList()
  const { unitOptions } = useFormattedZoneList(zoneList, currentLabel)
  const { spaceZoneOptions, spacesError, spacesLoading } = useSpaceZone()

  const { data: users, error: usersError, loading: userLoading } = useQuery(GET_USERS)

  const handleFilterEntities = useCallback((value: any) => {
    projectsFiltersVar(formatFiltersParams(value))
    localStorage.setItem(PROJECT_FILTER_STORAGE_NAME, JSON.stringify(value))
  }, [])

  const initialValues = useMemo(
    () => getFromLocalStorageDefValues(PROJECT_FILTER_STORAGE_NAME, PROJECT_FILTER_INIT_VALUES),
    []
  )

  useServerError([zoneError, usersError, spacesError])
  useLoading({ isLoading: zoneLoading || userLoading || spacesLoading })

  return spaceId || unitOptions.length ? (
    <FilterProjects
      projectsTotal={projectsTotal}
      users={users?.getUsers || []}
      unitsOptions={unitOptions}
      filterEntities={handleFilterEntities}
      initialValues={initialValues}
      isShownMyFilter={showMyFilterForZone}
      defaultValue={PROJECT_FILTER_INIT_VALUES}
      spacesOptions={spaceZoneOptions}
    />
  ) : null
}

export default FilterProjectsContainer
